// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import AutosubmitController from "./autosubmit_controller";
application.register("autosubmit", AutosubmitController);

import NavController from "./nav_controller";
application.register("nav", NavController);

import SelectController from "./select_controller";
application.register("select", SelectController);

import RevealController from "./reveal_controller";
application.register("reveal", RevealController);

import SearchController from "./search_controller";
application.register("search", SearchController);

import ToastsController from "./toasts_controller";
application.register("toasts", ToastsController);

import BroadcastFormController from "./broadcast_form_controller";
application.register("broadcast-form", BroadcastFormController);

import PollController from "./poll_controller";
application.register("poll", PollController);
